<template>
    <div class="row g-3 mb-4">
        <div ref="headerRef" class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">{{ title }}</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-3">
                <div class="col-12 col-md-4">
                    <label class="form-label">Numer dokumentu</label>
                    <input type="text" class="form-control" v-model="form.docNumber" placeholder="np. UZ/01/10/2026" />
                    
                    <div class="form-text small mt-1" v-if="lastDocuments.length > 0">
                        <span class="text-muted">Ostatnie: </span><br>
                        <span 
                            v-for="(item, idx) in lastDocuments" 
                            :key="idx" 
                            class="badge bg-secondary me-1 cursor-pointer" 
                        >
                            {{ item.docNumber }} z {{ formatDate(item.createDate) }}
                        </span>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <label class="form-label">* Data wystawienia</label>
                    <input type="date" class="form-control" v-model="form.issueDate" />
                </div>
                <div class="col-12 col-md-4">
                    <label class="form-label">Miejsce wystawienia</label>
                    <input type="text" class="form-control" v-model="form.issuePlace" />
                </div>
                <!-- <div class="col-12 col-md-4">
                    <label class="form-label">Numer faktury korygowanej</label>
                    <input type="text" class="form-control" v-model="form.correctedInvoiceNumber" />
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'

const props = defineProps({ 
    modelValue: { type: Object, required: true },
    title: { type: String, default: '1. Dane dokumentu' },
    lastDocuments: { type: Array, default: () => [] } // Opcjonalna lista ostatnich dokumentów
})
const emit = defineEmits(['update:modelValue'])

const headerRef = ref(null)
const sectionCollapse = ref(false)

const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})
const formatDate = (dateStr) => {
    if (!dateStr) return ''
    
    // Jeśli data przychodzi w formacie YYYY-MM-DD
    const parts = dateStr.split('-')
    if (parts.length === 3) {
        const [year, month, day] = parts
        return `${day}.${month}.${year}`
    }
    
    return dateStr
}
const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; user-select: none; }
</style>